module.exports = __webpack_public_path__ + "static/media/Right_Arrow_New.151676d1.svg";